var TorsoModel = require('backbone-torso/modules/Model'),
    urls = require('./../../urls');

/**
 * Model to hold the ereg configuration data.
 *
 * @class EregAuthConfigModel
 * @constructor
 */
module.exports = TorsoModel.extend({
  urlRoot: urls.portalAuthenticationConfigExtService
});
